export default __webpack_public_path__ + "static/media/example-1.ab5b632f.png";